var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 3.125H15.875V4.5H14.5V16.875L13.125 18.25H3.5L2.125 16.875V4.5H0.75V3.125H4.875V1.75C4.875 1.38533 5.01987 1.03559 5.27773 0.777728C5.53559 0.519866 5.88533 0.375 6.25 0.375H10.375C10.7397 0.375 11.0894 0.519866 11.3473 0.777728C11.6051 1.03559 11.75 1.38533 11.75 1.75V3.125ZM10.375 1.75H6.25V3.125H10.375V1.75ZM3.5 16.875H13.125V4.5H3.5V16.875ZM6.25 5.875H4.875V15.5H6.25V5.875ZM7.625 5.875H9V15.5H7.625V5.875ZM10.375 5.875H11.75V15.5H10.375V5.875Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f125e16201cd74512018d1c6bcd1e32c.svg";
export { ForwardRef as ReactComponent };